import React from "react";
import "./css/Footer.css"
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import HouseIcon from '@mui/icons-material/House';
import EmailIcon from '@mui/icons-material/Email';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import GoogleIcon from '@mui/icons-material/Google';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';


export const Footer = () => {
    return (

        <div className="tempContainer">
            <div className="box">
                <div>
                    <h2>PRICEWISE</h2>
                    <br></br>
                    <span>PriceWise is a popular price prediction platform that helps consumers find the best deals on a wide range of houses.</span>

                </div>
            </div>
            <div className="box">
                <h2>LINKS   </h2>
                <br></br>
                <div className="Links">
                    <a href="https://pricewise.netlify.app/">Home</a>
                    <a href="https://pricewise.netlify.app/Predict">Predict</a>
                    <a href="https://pricewise.netlify.app/Team">Our Team</a>
                    <a href="https://pricewise.netlify.app/Login">Login/ Sign up</a>
                </div>
            </div>
            <div className="box">
                <h2>    CONTACT   </h2>
                <br></br>
                <div className="contact">
                    <p className="sameRow"><HouseIcon /> <span>Bhopal, MP 462003, India</span></p>
                    <p className="sameRow"><EmailIcon /> <span>pricewise@info.com</span></p>
                    <p className="sameRow"><PhoneEnabledIcon /> <span>+01 234 567 89</span></p>
                </div>
            </div>
            <div className="box">
                <h2>FOLLOW US   </h2>
                <br></br>
                <FacebookRoundedIcon /> <TwitterIcon /> <GoogleIcon /> <br></br> <br></br> <InstagramIcon /> <LinkedInIcon /> <GitHubIcon />
            </div>
        </div>
    )
}